export default __webpack_public_path__ + "static/media/0xab0b2ddb9c7e440fac8e140a89c0dbcbf2d7bbff.3c4f4012.png";